import {css} from 'lit';
export const styles = css`:host {
  --background-primary: var(--gray-300);
  --text-primary: var(--dark-text-secondary);
  --font-size-primary: 26px;
  --element-size: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--element-size);
  height: var(--element-size);
  background-color: var(--background-primary);
  border-radius: 4px;
  color: var(--text-primary);
  font-size: var(--font-size-primary);
  overflow: hidden;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

:host([rounded]) {
  border-radius: 50%;
}
`;
export default styles;
